export {default as HeaderComponent} from './header';
export type {HeaderComponentProps} from './header.types';
